export default __webpack_public_path__ + "static/media/line-white.83c52acd.svg";